import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useMountedState } from "__barrel_optimize__?names=useMountedState!=!react-use";
import { useCloseAssetModal } from "~/components/AssetModalV2/hooks/useCloseAssetModal";
import { SectionDisplay } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/SectionDisplay";
import { ASSET_MODAL_KEYWORD } from "~/constants/testIDs";
import { useSearchParams } from "~/hooks/search/useSearchParams";
import { centralizedClipKeywordsSelector } from "~/store/centralizedClip/selectors";
export const REMOVE_SMART_TAG_BUTTON = "REMOVE_SMART_TAG_BUTTON";
export const KEYWORD_REMOVE_ICON = "KEYWORD_REMOVE_ICON";
export const SmartTagKeywords = /*#__PURE__*/ memo(()=>{
    const keywords = useSelector(centralizedClipKeywordsSelector);
    const isMounted = useMountedState();
    const { closeAssetModal } = useCloseAssetModal();
    const { setSearch } = useSearchParams();
    const onClick = useCallback(async (label)=>{
        await setSearch(label);
        if (isMounted()) {
            closeAssetModal();
        }
    }, [
        closeAssetModal,
        isMounted,
        setSearch
    ]);
    if (!(keywords === null || keywords === void 0 ? void 0 : keywords.length)) return null;
    return /*#__PURE__*/ _jsx(SectionDisplay, {
        title: "Smart Tags",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex flex-wrap items-baseline gap-1 space-y-1",
            children: keywords.map((keyword)=>/*#__PURE__*/ _jsx("div", {
                    className: "group relative",
                    children: /*#__PURE__*/ _jsx(Button, {
                        "data-testid": "".concat(ASSET_MODAL_KEYWORD, "-").concat(keyword.label),
                        appearance: "outline",
                        size: "small",
                        color: "grey",
                        className: "rounded-full",
                        onClick: ()=>onClick(keyword.label),
                        children: keyword.label
                    })
                }, keyword.id))
        })
    });
});
SmartTagKeywords.displayName = "SmartTagKeywords";
